function toReadableLabel(text: string): string {
  return text
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export default toReadableLabel;
